/*
  Selector de talla sobre la imagen de la card (catalogo), estilo JACK & JONES.
  Solo desktop (>= 768px). En mobile no arma nada y la card queda como esta hoy.

  Que hace:
  - Lee las tallas que card-size-hover.liquid dejo serializadas en la card
    (producto de la card + cada color hermano), asi que no hace ninguna peticion.
  - Arma los chips cuando la card esta por entrar en pantalla, o al primer hover.
  - Tallas tipo "28-32" (ancho-largo): las parte en dos pasos, primero el ancho y
    despues el largo, para no listar 14 combinaciones en una card.
  - Al elegir la talla final carga la variante en el <product-form> que ya trae la
    card y dispara su submit, o sea el mismo camino de "agregar al carrito" que
    usa hoy el desplegable. Todo el manejo de carrito/drawer sigue siendo del tema.
*/

(function () {
  'use strict';

  if (window.cardSizeHoverLoaded) return;
  window.cardSizeHoverLoaded = true;

  var DESKTOP = '(min-width: 768px)';
  var ALPHA_SIZES = ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '2XL', '3XL', '4XL', '5XL'];
  // "28-32", "L-32", "36/32": ancho + largo. El largo tiene que ser numerico y
  // cerrar el valor, para no partir tallas como "9-10 Años".
  var COMPOUND = /^(.+?)[-/](\d{1,3})$/;

  function isDesktop() {
    return window.matchMedia(DESKTOP).matches;
  }

  /* Orden de tallas: primero las alfabeticas (XS, S, M...), despues las numericas
     de menor a mayor, y lo que no reconocemos queda al final en su orden original. */
  function sizeRank(value) {
    var text = String(value == null ? '' : value).trim().toUpperCase();
    var alpha = ALPHA_SIZES.indexOf(text);
    if (alpha !== -1) return alpha;
    if (/^\d+([.,]\d+)?$/.test(text)) return 100 + parseFloat(text.replace(',', '.'));
    return 10000;
  }

  function byRank(getValue) {
    return function (a, b) {
      var diff = sizeRank(getValue(a)) - sizeRank(getValue(b));
      return diff !== 0 ? diff : a.index - b.index;
    };
  }

  function readSizes(panel) {
    if (panel.sizesByHandle) return panel.sizesByHandle;
    var node = panel.querySelector('.card-size-hover__data');
    if (!node) return null;
    try {
      panel.sizesByHandle = JSON.parse(node.textContent);
    } catch (error) {
      console.error('[card-size-hover] no se pudo leer las tallas de la card', error);
      panel.sizesByHandle = null;
    }
    return panel.sizesByHandle;
  }

  /* El color marcado manda: rocket-color-item.liquid ya deja el handle de cada
     color en data-handle, y es la misma clave con la que guardamos las tallas. */
  function currentHandle(card, panel) {
    var checked = card.querySelector('.rocket-color__input:checked');
    if (checked && checked.dataset.handle) return checked.dataset.handle;
    return panel.dataset.defaultHandle;
  }

  function buildChip(label, available, onSelect) {
    var chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'card-size-hover__chip';
    chip.textContent = label;
    if (!available) {
      chip.disabled = true;
      chip.setAttribute('aria-disabled', 'true');
    } else {
      chip.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        onSelect(chip);
      });
    }
    return chip;
  }

  function buildStep(legendText, chips) {
    var step = document.createElement('div');
    step.className = 'card-size-hover__step';

    if (legendText) {
      var legend = document.createElement('span');
      legend.className = 'card-size-hover__legend';
      legend.textContent = legendText;
      step.appendChild(legend);
    }

    var row = document.createElement('div');
    row.className = 'card-size-hover__row';
    chips.forEach(function (chip) {
      row.appendChild(chip);
    });
    step.appendChild(row);
    step.row = row;
    return step;
  }

  function addToCart(card, variantId, chip) {
    var panel = card.querySelector('[data-card-size-hover]');
    // El form propio del panel manda; el de la card queda como respaldo.
    var form =
      (panel && panel.querySelector('.card-size-hover__form form')) || card.querySelector('product-form form');
    var variantInput = form && form.querySelector('[name="id"]');
    if (!form || !variantInput) return;

    variantInput.disabled = false;
    variantInput.value = variantId;

    chip.classList.add('is-loading');
    window.setTimeout(function () {
      chip.classList.remove('is-loading');
    }, 1500);

    // product-form.js intercepta el submit y agrega por fetch. Si por lo que sea
    // no llego a cargar, requestSubmit hace el POST normal a /cart/add.
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  /* Agrupa "28-32" en ancho 28 -> largos [30, 32]. Devuelve null cuando el dos
     pasos no aporta: tallas simples, un solo ancho, o un unico largo por ancho. */
  function groupByWidth(items) {
    var lengthsByWidth = {};
    var widthOrder = [];

    for (var i = 0; i < items.length; i++) {
      var parts = COMPOUND.exec(items[i].label);
      if (!parts) return null;

      var width = parts[1].trim();
      if (!lengthsByWidth[width]) {
        lengthsByWidth[width] = [];
        widthOrder.push({ label: width, index: widthOrder.length });
      }
      lengthsByWidth[width].push({
        label: parts[2].trim(),
        id: items[i].id,
        available: items[i].available,
        index: lengthsByWidth[width].length,
      });
    }

    var maxLengths = 0;
    widthOrder.forEach(function (width) {
      maxLengths = Math.max(maxLengths, lengthsByWidth[width.label].length);
      lengthsByWidth[width.label].sort(byRank(function (entry) { return entry.label; }));
    });
    if (widthOrder.length < 2 || maxLengths < 2) return null;

    widthOrder.sort(byRank(function (entry) { return entry.label; }));
    return { widths: widthOrder, lengthsByWidth: lengthsByWidth };
  }

  function renderFlat(card, steps, labels, items) {
    var sorted = items.slice().sort(byRank(function (entry) { return entry.label; }));
    var chips = sorted.map(function (entry) {
      return buildChip(entry.label, entry.available, function (chip) {
        addToCart(card, entry.id, chip);
      });
    });
    steps.appendChild(buildStep(labels.labelSize, chips));
  }

  function renderTwoSteps(card, steps, labels, groups) {
    // El paso del largo va arriba a proposito: al abrirse el panel crece hacia la
    // imagen y la fila de anchos no se mueve de abajo del cursor.
    var lengthStep = buildStep(labels.labelLength, []);
    lengthStep.hidden = true;
    steps.appendChild(lengthStep);

    var widthChips = groups.widths.map(function (width) {
      var lengths = groups.lengthsByWidth[width.label];
      var anyAvailable = lengths.some(function (entry) { return entry.available; });

      return buildChip(width.label, anyAvailable, function (chip) {
        widthChips.forEach(function (other) { other.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');

        lengthStep.row.innerHTML = '';
        lengths.forEach(function (entry) {
          lengthStep.row.appendChild(
            buildChip(entry.label, entry.available, function (lengthChip) {
              addToCart(card, entry.id, lengthChip);
            })
          );
        });
        lengthStep.hidden = false;
      });
    });

    steps.appendChild(buildStep(labels.labelSize, widthChips));
  }

  function render(card, panel) {
    var sizesByHandle = readSizes(panel);
    var action = card.querySelector('.product-card__action');
    var sizes = sizesByHandle && sizesByHandle[currentHandle(card, panel)];
    // Se redibujan solo los pasos: el JSON y el <product-form> quedan intactos.
    var steps = panel.querySelector('.card-size-hover__steps');
    if (!steps) return;

    steps.innerHTML = '';
    panel.hidden = false;

    // Sin tallas para este color devolvemos la card al comportamiento original.
    if (!sizes || !sizes.length) {
      panel.hidden = true;
      panel.classList.remove('is-ready');
      if (action) action.classList.remove('has-size-hover');
      return;
    }

    var items = [];
    for (var i = 0; i < sizes.length; i++) {
      if (sizes[i][0] == null || sizes[i][0] === '') continue;
      items.push({ label: String(sizes[i][0]), id: sizes[i][1], available: sizes[i][2] === 1, index: i });
    }

    var groups = groupByWidth(items);
    if (groups) renderTwoSteps(card, steps, panel.dataset, groups);
    else renderFlat(card, steps, panel.dataset, items);

    panel.classList.add('is-ready');
    if (action) action.classList.add('has-size-hover');
  }

  function setup(card) {
    // setup() se llama desde mouseover, asi que sale por la bandera antes de tocar el DOM.
    if (card.sizeHoverDone || !isDesktop()) return;
    card.sizeHoverDone = true;

    // En el carrito la card es angosta y ya tiene su propio flujo de quick add.
    if (card.closest('.cart-drawer')) return;

    var panel = card.querySelector('[data-card-size-hover]');
    if (!panel || panel.dataset.ready === 'true') return;

    panel.dataset.ready = 'true';
    render(card, panel);

    // Al salir de la card volvemos al primer paso, para no dejar un largo abierto.
    card.addEventListener('mouseleave', function () {
      if (panel.querySelector('.card-size-hover__chip[aria-pressed="true"]')) render(card, panel);
    });
  }

  var idle =
    window.requestIdleCallback ||
    function (callback) {
      return window.setTimeout(callback, 1);
    };

  // Se arman las cards que estan por entrar en pantalla, asi al llegar el mouse
  // el panel ya existe y no se ve el boton viejo asomando.
  var observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              observer.unobserve(entry.target);
              idle(function () {
                setup(entry.target);
              });
            });
          },
          { rootMargin: '300px 0px' }
        )
      : null;

  function scan() {
    if (!isDesktop()) return;
    document.querySelectorAll('[data-card-size-hover]').forEach(function (panel) {
      var card = panel.closest('rocket-product-card') || panel.closest('.card-wrapper');
      if (!card || panel.dataset.ready === 'true' || panel.dataset.observed === 'true') return;
      if (observer) {
        panel.dataset.observed = 'true';
        observer.observe(card);
      } else {
        setup(card);
      }
    });
  }

  // Red de seguridad: cards que aparecen despues (filtros, "ver mas", carruseles).
  document.addEventListener(
    'mouseover',
    function (event) {
      if (!isDesktop() || !event.target || !event.target.closest) return;
      var card = event.target.closest('rocket-product-card') || event.target.closest('.card-wrapper');
      if (card) setup(card);
    },
    { passive: true }
  );

  // Cambio de color: el panel se rearma con las tallas de ese color.
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.classList || !input.classList.contains('rocket-color__input')) return;

    var card = input.closest('rocket-product-card') || input.closest('.card-wrapper');
    var panel = card && card.querySelector('[data-card-size-hover]');
    if (panel && panel.dataset.ready === 'true') render(card, panel);
  });

  // scan() recorre el documento, asi que las mutaciones se agrupan en un solo pase.
  var scanQueued = false;
  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    idle(function () {
      scanQueued = false;
      scan();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();

  document.addEventListener('shopify:section:load', queueScan);
  window.addEventListener('pageshow', queueScan);
  new MutationObserver(queueScan).observe(document.body || document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
